import { IBankCreate, IBankDetails, IEditBankPayload, IBankListSearch, IGetBankList } from "../../../types/master/bankInterface";
import { BankActionTypes, BankActions } from "../../actionTypes/master/bankActionTypes";

export const createBank = (payload: IBankCreate): BankActionTypes => ({
  type: BankActions.CREATE_BANK,
  payload,
});

export const getBankList = (payload: IBankListSearch): BankActionTypes => ({
  type: BankActions.GET_BANK_LIST,
  payload,
});

export const setBankList = (branchList: Array<IGetBankList>): BankActionTypes => ({
  type: BankActions.SET_BANK_LIST,
  payload: branchList,
});

export const setBankListPageCount = (payload: number): BankActionTypes => ({
  type: BankActions.SET_BANK_LIST_PAGE_COUNT,
  payload,
});

export const getBankDataById = (id: number | string): BankActionTypes => ({
  type: BankActions.GET_BANK_DATA_BY_ID,
  payload: id,
});

export const setBankDataById = (payload: IBankDetails): BankActionTypes => ({
  type: BankActions.SET_BANK_DATA_BY_ID,
  payload,
});

export const editBank = (payload: IEditBankPayload): BankActionTypes => ({
  type: BankActions.EDIT_BANK_DATA_BY_ID,
  payload,
});
